import { FC } from 'react';
import { Box, IconButton, Stack } from '@mui/material';

import { SkeletonBlock } from '../../atoms/SkeletonBlock';
import { LeftChevronIcon } from '../../icons';

export interface MplTopSectionHeaderLoadingProps {
	onBack?: VoidFunction;
}

export const MplTopSectionHeaderLoading: FC<
	MplTopSectionHeaderLoadingProps
> = ({ onBack }) => {
	return (
		<Stack
			direction="row"
			width="100%"
			color="primary.main"
			alignItems="center"
		>
			<Box sx={{ width: 48, flexShrink: 0 }}>
				{onBack && (
					<IconButton onClick={onBack}>
						<LeftChevronIcon />
					</IconButton>
				)}
			</Box>

			<Stack
				direction="column"
				alignItems="center"
				sx={{
					flex: 1,
					textAlign: 'center',
					minWidth: 0,
				}}
			>
				<SkeletonBlock w={160} h={24} r={8} />
			</Stack>

			<Box
				sx={{
					width: 48,
					flexShrink: 0,
					display: 'flex',
					justifyContent: 'flex-end',
				}}
			>
				<SkeletonBlock w={32} h={32} r={16} />
			</Box>
		</Stack>
	);
};
